export const timezones = {
	'Africa/Abidjan': '(GMT+00:00) Abidjan',
	'Africa/Accra': '(GMT+00:00) Accra',
	'Africa/Algiers': '(GMT+01:00) Algiers',
	'Africa/Bissau': '(GMT+00:00) Bissau',
	'Africa/Cairo': '(GMT+02:00) Cairo',
	'Africa/Casablanca': '(GMT+00:00) Casablanca',
	'Africa/Ceuta': '(GMT+01:00) Ceuta',
	'Africa/El_Aaiun': '(GMT+00:00) El Aaiun',
	'Africa/Johannesburg': '(GMT+02:00) Johannesburg',
	'Africa/Khartoum': '(GMT+03:00) Khartoum',
	'Africa/Lagos': '(GMT+01:00) Lagos',
	'Africa/Maputo': '(GMT+02:00) Maputo',
	'Africa/Monrovia': '(GMT+00:00) Monrovia',
	'Africa/Nairobi': '(GMT+03:00) Nairobi',
	'Africa/Ndjamena': '(GMT+01:00) Ndjamena',
	'Africa/Tripoli': '(GMT+02:00) Tripoli',
	'Africa/Tunis': '(GMT+01:00) Tunis',
	'Africa/Windhoek': '(GMT+02:00) Windhoek',
	'America/Anchorage': '(GMT-09:00) Alaska Time',
	'America/Araguaina': '(GMT-03:00) Araguaina',
	'America/Argentina/Buenos_Aires': '(GMT-03:00) Buenos Aires',
	'America/Asuncion': '(GMT-03:00) Asuncion',
	'America/Bahia': '(GMT-03:00) Salvador',
	'America/Barbados': '(GMT-04:00) Barbados',
	'America/Belem': '(GMT-03:00) Belém',
	'America/Belize': '(GMT-06:00) Belize',
	'America/Boa_Vista': '(GMT-04:00) Boa Vista',
	'America/Bogota': '(GMT-05:00) Bogota',
	'America/Campo_Grande': '(GMT-03:00) Campo Grande',
	'America/Cancun': '(GMT-05:00) America Cancun',
	'America/Caracas': '(GMT-04:30) Caracas',
	'America/Cayenne': '(GMT-03:00) Cayenne',
	'America/Cayman': '(GMT-05:00) Cayman',
	'America/Chicago': '(GMT-06:00) Central Time',
	'America/Costa_Rica': '(GMT-06:00) Costa Rica',
	'America/Cuiaba': '(GMT-03:00) Cuiaba',
	'America/Curacao': '(GMT-04:00) Curacao',
	'America/Danmarkshavn': '(GMT+00:00) Danmarkshavn',
	'America/Dawson_Creek': '(GMT-07:00) Mountain Time - Dawson Creek',
	'America/Denver': '(GMT-07:00) Mountain Time',
	'America/Edmonton': '(GMT-07:00) Mountain Time - Edmonton',
	'America/El_Salvador': '(GMT-06:00) El Salvador',
	'America/Fortaleza': '(GMT-03:00) Fortaleza',
	'America/Godthab': '(GMT-03:00) Godthab',
	'America/Grand_Turk': '(GMT-04:00) Grand Turk',
	'America/Guatemala': '(GMT-06:00) Guatemala',
	'America/Guayaquil': '(GMT-05:00) Guayaquil',
	'America/Guyana': '(GMT-04:00) Guyana',
	'America/Halifax': '(GMT-04:00) Atlantic Time - Halifax',
	'America/Havana': '(GMT-05:00) Havana',
	'America/Hermosillo': '(GMT-07:00) Mountain Time - Hermosillo',
	'America/Iqaluit': '(GMT-05:00) Eastern Time - Iqaluit',
	'America/Jamaica': '(GMT-05:00) Jamaica',
	'America/La_Paz': '(GMT-04:00) La Paz',
	'America/Lima': '(GMT-05:00) Lima',
	'America/Los_Angeles': '(GMT-08:00) Pacific Time',
	'America/Maceio': '(GMT-03:00) Maceio',
	'America/Managua': '(GMT-06:00) Managua',
	'America/Manaus': '(GMT-04:00) Manaus',
	'America/Martinique': '(GMT-04:00) Martinique',
	'America/Mazatlan': '(GMT-07:00) Mountain Time - Chihuahua, Mazatlan',
	'America/Mexico_City': '(GMT-06:00) Central Time - Mexico City',
	'America/Miquelon': '(GMT-03:00) Miquelon',
	'America/Montevideo': '(GMT-03:00) Montevideo',
	'America/Nassau': '(GMT-05:00) Nassau',
	'America/New_York': '(GMT-05:00) Eastern Time',
	'America/Noronha': '(GMT-02:00) Noronha',
	'America/Panama': '(GMT-05:00) Panama',
	'America/Paramaribo': '(GMT-03:00) Paramaribo',
	'America/Phoenix': '(GMT-07:00) Mountain Time - Arizona',
	'America/Port_of_Spain': '(GMT-04:00) Port of Spain',
	'America/Port-au-Prince': '(GMT-05:00) Port-au-Prince',
	'America/Porto_Velho': '(GMT-04:00) Porto Velho',
	'America/Puerto_Rico': '(GMT-04:00) Puerto Rico',
	'America/Recife': '(GMT-03:00) Recife',
	'America/Regina': '(GMT-06:00) Central Time - Regina',
	'America/Rio_Branco': '(GMT-05:00) Rio Branco',
	'America/Santiago': '(GMT-03:00) Santiago',
	'America/Santo_Domingo': '(GMT-04:00) Santo Domingo',
	'America/Sao_Paulo': '(GMT-03:00) São Paulo',
	'America/Scoresbysund': '(GMT-01:00) Scoresbysund',
	'America/St_Johns': '(GMT-03:30) Newfoundland Time - St. Johns',
	'America/Tegucigalpa': '(GMT-06:00) Central Time - Tegucigalpa',
	'America/Thule': '(GMT-04:00) Thule',
	'America/Tijuana': '(GMT-08:00) Pacific Time - Tijuana',
	'America/Toronto': '(GMT-05:00) Eastern Time - Toronto',
	'America/Vancouver': '(GMT-08:00) Pacific Time - Vancouver',
	'America/Whitehorse': '(GMT-08:00) Pacific Time - Whitehorse',
	'America/Winnipeg': '(GMT-06:00) Central Time - Winnipeg',
	'America/Yellowknife': '(GMT-07:00) Mountain Time - Yellowknife',
	'Antarctica/Casey': '(GMT+08:00) Casey',
	'Antarctica/Davis': '(GMT+07:00) Davis',
	'Antarctica/DumontDUrville': "(GMT+10:00) Dumont D'Urville",
	'Antarctica/Mawson': '(GMT+05:00) Mawson',
	'Antarctica/Palmer': '(GMT-03:00) Palmer',
	'Antarctica/Rothera': '(GMT-03:00) Rothera',
	'Antarctica/Syowa': '(GMT+03:00) Syowa',
	'Antarctica/Vostok': '(GMT+06:00) Vostok',
	'Asia/Almaty': '(GMT+06:00) Almaty',
	'Asia/Amman': '(GMT+02:00) Amman',
	'Asia/Aqtau': '(GMT+05:00) Aqtau',
	'Asia/Aqtobe': '(GMT+05:00) Aqtobe',
	'Asia/Ashgabat': '(GMT+05:00) Ashgabat',
	'Asia/Baghdad': '(GMT+03:00) Baghdad',
	'Asia/Baku': '(GMT+04:00) Baku',
	'Asia/Bangkok': '(GMT+07:00) Bangkok',
	'Asia/Beirut': '(GMT+02:00) Beirut',
	'Asia/Bishkek': '(GMT+06:00) Bishkek',
	'Asia/Brunei': '(GMT+08:00) Brunei',
	'Asia/Calcutta': '(GMT+05:30) India Standard Time',
	'Asia/Choibalsan': '(GMT+08:00) Choibalsan',
	'Asia/Colombo': '(GMT+05:30) Colombo',
	'Asia/Damascus': '(GMT+02:00) Damascus',
	'Asia/Dhaka': '(GMT+06:00) Dhaka',
	'Asia/Dili': '(GMT+09:00) Dili',
	'Asia/Dubai': '(GMT+04:00) Dubai',
	'Asia/Dushanbe': '(GMT+05:00) Dushanbe',
	'Asia/Gaza': '(GMT+02:00) Gaza',
	'Asia/Ho_Chi_Minh': '(GMT+07:00) Ho Chi Minh',
	'Asia/Hong_Kong': '(GMT+08:00) Hong Kong',
	'Asia/Hovd': '(GMT+07:00) Hovd',
	'Asia/Irkutsk': '(GMT+08:00) Moscow+05 - Irkutsk',
	'Asia/Jakarta': '(GMT+07:00) Jakarta',
	'Asia/Jayapura': '(GMT+09:00) Jayapura',
	'Asia/Jerusalem': '(GMT+02:00) Jerusalem',
	'Asia/Kabul': '(GMT+04:30) Kabul',
	'Asia/Kamchatka': '(GMT+12:00) Moscow+09 - Petropavlovsk-Kamchatskiy',
	'Asia/Karachi': '(GMT+05:00) Karachi',
	'Asia/Katmandu': '(GMT+05:45) Katmandu',
	'Asia/Krasnoyarsk': '(GMT+07:00) Moscow+04 - Krasnoyarsk',
	'Asia/Kuala_Lumpur': '(GMT+08:00) Kuala Lumpur',
	'Asia/Macau': '(GMT+08:00) Macau',
	'Asia/Magadan': '(GMT+10:00) Moscow+07 - Magadan',
	'Asia/Makassar': '(GMT+08:00) Makassar',
	'Asia/Manila': '(GMT+08:00) Manila',
	'Asia/Nicosia': '(GMT+02:00) Nicosia',
	'Asia/Omsk': '(GMT+06:00) Moscow+03 - Omsk, Novosibirsk',
	'Asia/Pyongyang': '(GMT+08:30) Pyongyang',
	'Asia/Qatar': '(GMT+03:00) Qatar',
	'Asia/Rangoon': '(GMT+06:30) Rangoon',
	'Asia/Riyadh': '(GMT+03:00) Riyadh',
	'Asia/Saigon': '(GMT+07:00) Hanoi',
	'Asia/Seoul': '(GMT+09:00) Seoul',
	'Asia/Shanghai': '(GMT+08:00) China Time - Beijing',
	'Asia/Singapore': '(GMT+08:00) Singapore',
	'Asia/Taipei': '(GMT+08:00) Taipei',
	'Asia/Tashkent': '(GMT+05:00) Tashkent',
	'Asia/Tbilisi': '(GMT+04:00) Tbilisi',
	'Asia/Tehran': '(GMT+03:30) Tehran',
	'Asia/Thimphu': '(GMT+06:00) Thimphu',
	'Asia/Tokyo': '(GMT+09:00) Tokyo',
	'Asia/Ulaanbaatar': '(GMT+08:00) Ulaanbaatar',
	'Asia/Vladivostok': '(GMT+10:00) Moscow+07 - Yuzhno-Sakhalinsk',
	'Asia/Yakutsk': '(GMT+09:00) Moscow+06 - Yakutsk',
	'Asia/Yekaterinburg': '(GMT+05:00) Moscow+02 - Yekaterinburg',
	'Asia/Yerevan': '(GMT+04:00) Yerevan',
	'Atlantic/Azores': '(GMT-01:00) Azores',
	'Atlantic/Bermuda': '(GMT-04:00) Bermuda',
	'Atlantic/Canary': '(GMT+00:00) Canary Islands',
	'Atlantic/Cape_Verde': '(GMT-01:00) Cape Verde',
	'Atlantic/Faroe': '(GMT+00:00) Faeroe',
	'Atlantic/Reykjavik': '(GMT+00:00) Reykjavik',
	'Atlantic/South_Georgia': '(GMT-02:00) South Georgia',
	'Atlantic/Stanley': '(GMT-03:00) Stanley',
	'Australia/Adelaide': '(GMT+10:30) Central Time - Adelaide',
	'Australia/Brisbane': '(GMT+10:00) Eastern Time - Brisbane',
	'Australia/Darwin': '(GMT+09:30) Central Time - Darwin',
	'Australia/Hobart': '(GMT+11:00) Eastern Time - Hobart',
	'Australia/Perth': '(GMT+08:00) Western Time - Perth',
	'Australia/Sydney': '(GMT+11:00) Eastern Time - Melbourne, Sydney',
	'Etc/GMT': '(GMT+00:00) GMT (no daylight saving)',
	'Europe/Amsterdam': '(GMT+01:00) Amsterdam',
	'Europe/Andorra': '(GMT+01:00) Andorra',
	'Europe/Athens': '(GMT+02:00) Athens',
	'Europe/Belgrade': '(GMT+01:00) Central European Time - Belgrade',
	'Europe/Berlin': '(GMT+01:00) Berlin',
	'Europe/Brussels': '(GMT+01:00) Brussels',
	'Europe/Bucharest': '(GMT+02:00) Bucharest',
	'Europe/Budapest': '(GMT+01:00) Budapest',
	'Europe/Chisinau': '(GMT+02:00) Chisinau',
	'Europe/Copenhagen': '(GMT+01:00) Copenhagen',
	'Europe/Dublin': '(GMT+00:00) Dublin',
	'Europe/Gibraltar': '(GMT+01:00) Gibraltar',
	'Europe/Helsinki': '(GMT+02:00) Helsinki',
	'Europe/Istanbul': '(GMT+02:00) Istanbul',
	'Europe/Kaliningrad': '(GMT+02:00) Moscow-01 - Kaliningrad',
	'Europe/Kiev': '(GMT+02:00) Kiev',
	'Europe/Lisbon': '(GMT+00:00) Lisbon',
	'Europe/London': '(GMT+00:00) London',
	'Europe/Luxembourg': '(GMT+01:00) Luxembourg',
	'Europe/Madrid': '(GMT+01:00) Madrid',
	'Europe/Malta': '(GMT+01:00) Malta',
	'Europe/Minsk': '(GMT+03:00) Minsk',
	'Europe/Monaco': '(GMT+01:00) Monaco',
	'Europe/Moscow': '(GMT+03:00) Moscow+00 - Moscow',
	'Europe/Oslo': '(GMT+01:00) Oslo',
	'Europe/Paris': '(GMT+01:00) Paris',
	'Europe/Prague': '(GMT+01:00) Central European Time - Prague',
	'Europe/Riga': '(GMT+02:00) Riga',
	'Europe/Rome': '(GMT+01:00) Rome',
	'Europe/Samara': '(GMT+04:00) Moscow+01 - Samara',
	'Europe/Sofia': '(GMT+02:00) Sofia',
	'Europe/Stockholm': '(GMT+01:00) Stockholm',
	'Europe/Tallinn': '(GMT+02:00) Tallinn',
	'Europe/Tirane': '(GMT+01:00) Tirane',
	'Europe/Vienna': '(GMT+01:00) Vienna',
	'Europe/Vilnius': '(GMT+02:00) Vilnius',
	'Europe/Warsaw': '(GMT+01:00) Warsaw',
	'Europe/Zurich': '(GMT+01:00) Zurich',
	'Indian/Chagos': '(GMT+06:00) Chagos',
	'Indian/Christmas': '(GMT+07:00) Christmas',
	'Indian/Cocos': '(GMT+06:30) Cocos',
	'Indian/Kerguelen': '(GMT+05:00) Kerguelen',
	'Indian/Mahe': '(GMT+04:00) Mahe',
	'Indian/Maldives': '(GMT+05:00) Maldives',
	'Indian/Mauritius': '(GMT+04:00) Mauritius',
	'Indian/Reunion': '(GMT+04:00) Reunion',
	'Pacific/Apia': '(GMT+14:00) Apia',
	'Pacific/Auckland': '(GMT+13:00) Auckland',
	'Pacific/Chuuk': '(GMT+10:00) Truk',
	'Pacific/Easter': '(GMT-05:00) Easter Island',
	'Pacific/Efate': '(GMT+11:00) Efate',
	'Pacific/Enderbury': '(GMT+13:00) Enderbury',
	'Pacific/Fakaofo': '(GMT+13:00) Fakaofo',
	'Pacific/Fiji': '(GMT+13:00) Fiji',
	'Pacific/Funafuti': '(GMT+12:00) Funafuti',
	'Pacific/Galapagos': '(GMT-06:00) Galapagos',
	'Pacific/Gambier': '(GMT-09:00) Gambier',
	'Pacific/Guadalcanal': '(GMT+11:00) Guadalcanal',
	'Pacific/Guam': '(GMT+10:00) Guam',
	'Pacific/Honolulu': '(GMT-10:00) Hawaii Time',
	'Pacific/Kiritimati': '(GMT+14:00) Kiritimati',
	'Pacific/Kosrae': '(GMT+11:00) Kosrae',
	'Pacific/Kwajalein': '(GMT+12:00) Kwajalein',
	'Pacific/Majuro': '(GMT+12:00) Majuro',
	'Pacific/Marquesas': '(GMT-09:30) Marquesas',
	'Pacific/Nauru': '(GMT+12:00) Nauru',
	'Pacific/Niue': '(GMT-11:00) Niue',
	'Pacific/Norfolk': '(GMT+11:00) Norfolk',
	'Pacific/Noumea': '(GMT+11:00) Noumea',
	'Pacific/Pago_Pago': '(GMT-11:00) Pago Pago',
	'Pacific/Palau': '(GMT+09:00) Palau',
	'Pacific/Pitcairn': '(GMT-08:00) Pitcairn',
	'Pacific/Pohnpei': '(GMT+11:00) Ponape',
	'Pacific/Port_Moresby': '(GMT+10:00) Port Moresby',
	'Pacific/Rarotonga': '(GMT-10:00) Rarotonga',
	'Pacific/Tahiti': '(GMT-10:00) Tahiti',
	'Pacific/Tarawa': '(GMT+12:00) Tarawa',
	'Pacific/Tongatapu': '(GMT+13:00) Tongatapu',
	'Pacific/Wake': '(GMT+12:00) Wake',
	'Pacific/Wallis': '(GMT+12:00) Wallis',
};
